import React, { useEffect, useState } from "react";
import "./index.scss";
import Card from "lib/Card";
import Modal from 'react-bootstrap/Modal'
import Spinner from 'react-bootstrap/Spinner';
import Image from "lib/Image";
import { Search } from "lib";
import Download_icon from "assets/images/download_icon.svg";
import DashBoard from "components/DashBoard";
// import { dashboardListingConfig as dashboardConfig } from "assets/dashboardListingConfig";
import TableComponent from "components/DashboardTable";
import { useDispatch, useSelector } from "react-redux";
import Sign_desk_logo from "assets/images/signdesk_logo.svg";
import signdeskLogo from "assets/images/signdesk_logo.svg";
// import { Image } from "react-bootstrap"
import Header from 'components/Header'; 
import {
  getDashboardListDetails,
  getAllUsersByOrg,
  downloadMISReport,
  getFilterDropdownOptions
} from "api/dashboard";
import {
  setDashboardState,
  setDashboardCheckboxList,
  setFilterCheckboxList,
  clearAllFilterCheckBox,
  setDateFilterCheckboxList,
  setAllDashboardCkeckboxList,
  setloadingAppplicantDataToDownload,
  setAllFilterCheckBoxList,
  setRowPerPage,
  setSelectedTableSortOptions,
  setBulkVerifiedResponse,
} from "redux/dashboardReducer";
import { debounceFunc, setAppColor } from "helper";
import { setIsUserClicked } from "redux/usersReducer";
import { clearRecursiveFormData } from "redux/recursiveReducer";
import { clearSelectedData } from "redux/formDisplay";
import { setActiveStepOrder } from "redux/conditionalRendering";
import { downloadReport } from "api/downloadReport";
import { updateDataAndStatusById } from "api/dashboardDetail";
import { findAndUpdateArray } from "helper/common";
import Toast from "components/ToastComponent";
import { log } from "@craco/craco/lib/logger";
import InviteCustomer from "components/InviteCustomer";
// import BulkInviteCustomer from "components/BulkInviteCustomer"
import BulkAddCustomer from "components/BulkAddCustomer";
import { clearUrlParams } from "redux/urlEncryption";
import { clearActivityList, clearTotal } from "redux/activityListReducer";
import { createLinkExpiry } from "api/configuration";
import { getRolesInfo,getUserNamesByIds } from "api/user";
import Autologout from "helper/Autologout";
import { Row, Col, Container, Dropdown, Button } from 'react-bootstrap'
import PaginationComponent from "lib/Pagination";
import { setRowsChange } from "redux/dashboardReducer";
// import Navbar from 'react-bootstrap/Navbar';
// import { getProfilePicName } from "helper/common";
// import Nav from 'react-bootstrap/Nav';
import LoadingSpinner from "lib/LoadingSpinner";
import { LOGIN_ROUTE } from "constants/routes";


// import BulkAddCustomer from "components/BulkAddCustomer";
// import { setCurrentModuleOfUser } from "redux/currentModuleReducer";

const HomePage = () => {
  const dispatch = useDispatch();
  const convertedToCSV = useSelector(
    (state) => state.downloadRepo.convertedToCSV
  );
  const loading = useSelector((state) => state.dashboardReducer.loading);
  const dashboardDataLoading =  useSelector((state) => state.dashboardReducer.dashboardDataLoading);
  // const sidebarStructure = useSelector((state) => state.dashboardReducer?.rolesInfo?.sidebar_structure)
  const sidebarLoading = useSelector((state) => state.dashboardReducer.sidebarLoading);
  const headerLoading = useSelector((state) => state.dashboardReducer.headerLoading);
  const rowsPerPage = useSelector((state) => state.dashboardReducer.rowPerPage);
  const changeRows = useSelector((state) => state.dashboardReducer.checkRowsChange);
  const {
    dashboardFields,
    dashboardFieldsCheckboxList,
    filterDropdownList,
    dashboardConfig,
    checkboxList,
    selectedFilterCheckboxList,
    dateFilterCheckboxList,
    tableListingData,
    tableListingAllData,
    workflowDelete,
    tableCount,
    current_module,
    allUsers,
    activeSelectedTab
  } = useSelector((state) => state.dashboardReducer);
  const loggedInUserInfo = useSelector(
    (state) => state.loggedInUserInfo?.userAuthInfo
  );
  const [dashboardTableListingData, setDashboardTableListingData] =
    useState(tableListingData);
  const [isDownloadLoaded, setIsDownloadLoaded] = useState(false);
  const [dashboardSidebar, setDashboardSidebar] = useState();
  const [pagination, setPagination] = useState({
    pageNum: 1,
    count: 1,
  });
  const [allFilterArray, setAllFilterArray] = useState({});
  const [smShow, setSmShow] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [invite, setInvite] = useState(false);
  const [addbulk, setAddbulk] = useState(false);
  const [Bulkinvite, setBulkInvite] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showBulkModal, setshowBulkModal] = useState(false)
  const [showAddModal,setshowAddModall]=useState(false)
  const [toast, setToast] = useState(false);
  const [sessiontimeout, setSessionTimeout] = useState(false)
  const [defaultDuration, setDefaultDuration] = useState('')
  const [isMobile, setIsMobile] = useState(false);
  const [listing, setListing] = useState(false);
  const [headerStructure, setHeaderStructure] = useState();
  const [internalPOCUpdatedSuccessfully, setInternalPOCUpdatedSuccessfully] =
    useState(false);
  const [poweredBy, setPoweredBy] = useState(false);
  const currentUserRole =
    loggedInUserInfo?.modules?.find(
      (module) => module?.module_id === current_module?.id
    ) || {};
  const selectedData = { ...currentUserRole };
  const [download, setDownload] = useState(true);
  const [searchBarSize, setSearchBarSize] = useState('')
  const [ctaContainerStyle, setCtaContainerStyle] = useState(2)
  const [showClearFilter,setClearFilter] = useState(false);
  const [show, setShow] = useState(false);
  const [removeFilter, setRemoveFilter] = useState({});
  const [defaultTextFilter, setDefaultTextFilter] = useState({});
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const clientLogoutURL = useSelector((state) => state?.loggedInUserInfo?.userAuthInfo?.organisationInfo)?.setting?.logout_url;
  const [toggleIcon,setToggleIcon]=useState(false)
  const IsLoggedInUseFetched = loggedInUserInfo?.organisationInfo?.layout_setting
  const numberOfRecords = useSelector((state) => state.dashboardReducer.numberOfRecords);
  const selectedTableSortOptions = useSelector(state => state.dashboardReducer.selectedTableSortOptions);
  const [sortOptions, setSortOptions] = useState({});
  const [globalFilterRequired, setGloablFilterRequired] = useState(true);
  const [ignoreFilter,setIgnoreFilter] = useState(false)
  const bulkVerifiedResponse = useSelector((state) => state.dashboardReducer.bulkVerifiedResponse);
  const searchBarConfig = headerStructure?.list_items?.find?.(item => item?.name === "search_bar")
  const user_data = loggedInUserInfo && {
    user_id: loggedInUserInfo?.profileInfo?.userId,
    role_id: loggedInUserInfo?.profileInfo?.role,
    email_id: loggedInUserInfo?.profileInfo?.emailId,
  };
    const userHierarchy = useSelector((state)=>state.dashboardReducer?.dashboardConfig?.user_hierarchy)

  dispatch(clearUrlParams())
  dispatch(clearActivityList())
  dispatch(clearTotal())

  useEffect(() => {
    if (changeRows) {
      setPagination((prev) => ({
        ...prev,
        pageNum: 1,
      }));
      handlePageClick("first");
    }
  }, [changeRows]);

  const clearAllFilterArray = () =>{
    setAllFilterArray({})
    setIgnoreFilter(false)
  }

  const clearAllsortArray = (ignoreFilter) =>{
    setIgnoreFilter(ignoreFilter)

  }
  useEffect(() => {
    if(dashboardConfig?.header_structure){
      setHeaderStructure(dashboardConfig?.header_structure)
      
      let headerStructureList = dashboardConfig?.header_structure?.list_items;
      let filters = headerStructureList?.find((item) => item?.type === "filters");
      if(filters?.global_filter) {
        setGloablFilterRequired(true);
      } else setGloablFilterRequired(false);
    }
  }, [dashboardConfig?.header_structure])

  useEffect(() => {
    setAppColor(IsLoggedInUseFetched)
    if (loggedInUserInfo?.organisationInfo?._id && !current_module?.id) {
      let modules = {};
      let currentModule = {};
      loggedInUserInfo?.modules.forEach((ele) => {
        modules[ele.module_name] = ele.module_id;
        if (ele.is_default || ele.module_name === "low_code_dashboard") {
          currentModule = {
            id: ele.module_id,
            name: ele.module_name,
          };
        }
        if (ele?.module_name === "low_code_detail_view") {
          currentModule.detail_view_module_id = ele.module_id;
        }
      });
      dispatch(
        setDashboardState({ key: "current_module", value: currentModule })
      );
      // setAppColor(loggedInUserInfo?.userAuthInfo?.organisationInfo?.layout_setting)
      dispatch(setDashboardState({ key: "workflow_modules", value: modules }));
    }
     /**Effect to show fav icon and logo */
     let orgData = loggedInUserInfo?.organisationInfo;
     
     setPoweredBy(orgData?.white_labeled ? orgData?.white_labeled : false);
     const list = document.getElementById('favicon_customized');
    //  list.href = '/unified/' + (orgData?.fav_icon ? orgData?.fav_icon : 'signdesk_logo@2x.png');
    if(orgData?.icon){
      list.href = `https://signdesk.in/company/${orgData?.icon}`
    }
     const titleName = document.getElementById('title-id');
     titleName.innerText = orgData?.setting?.parent_client_name || "loading...";

     /**Effect for autologout */
     const sessionDuration = loggedInUserInfo?.organisationInfo?.setting?.logout_duration
     let logoutDuration = sessionDuration ? sessionDuration : 20
     logoutDuration = logoutDuration * 60 * 1000
     setDefaultDuration(logoutDuration)
     // uncomment to test in local
     // let logoutDuration = sessionDuration ? sessionDuration : 80
     // logoutDuration = logoutDuration * 60 * 1000
     
     /**Effect to show sidebar */
    if (!dashboardConfig?.sidebar_structure) {
      try {
        let userToken = JSON.parse(localStorage.getItem("userToken"));
        if (userToken === null) {
          localStorage.clear();
          window.location.href = LOGIN_ROUTE
        }
        let queryParams = {
          role_id: userToken?.role ? userToken?.role : loggedInUserInfo?.profileInfo?.role,
          organisation_id: userToken?.userOrg ? userToken?.userOrg : loggedInUserInfo?.organisationInfo?._id
        }
        dispatch(getRolesInfo(queryParams))
         
      } catch (err) {
        localStorage.clear();
        window.location.href = LOGIN_ROUTE
       }
     }
  }, [loggedInUserInfo, current_module]);

  useEffect(() => {
    setDashboardSidebar(dashboardConfig?.sidebar_structure)
    if (dashboardConfig?.sidebar_structure) {
      const moduleInfo = dashboardConfig?.sidebar_structure?.list_items.filter((item) => item?.list_name == "Workflows");
      setDownload(eval(moduleInfo[0]?.show));
    }
  }, [dashboardConfig?.sidebar_structure, sidebarLoading])

  const sessionTrigger = () => {
    if (defaultDuration) {
      setSessionTimeout(true)
    }
  }

  const handleSearch = debounceFunc((value) => {
    setSearchValue(value?.toLowerCase() || "");
    setPagination((prev) => ({
      ...prev,
      pageNum: 1,
    }));
    const refId = value;
  if (userHierarchy && refId) {
    dispatch(getUserNamesByIds({ application_ref_id: refId }));
  }
  }, 500);

  setTimeout(() => {
    sessionTrigger()
  }, defaultDuration)

  const getDashboardList = () => {
    if (current_module?.id && loggedInUserInfo?.organisationInfo?._id ) {
      dispatch(
        getDashboardListDetails({
          module_id: current_module?.id,
          organisation_id: loggedInUserInfo?.organisationInfo?._id,
          limit: 10,
          skip: (pagination?.pageNum - 1) * 10,
          searchText: searchValue,
          user_data,
          selectedFilter:allFilterArray,
          emailId: loggedInUserInfo?.profileInfo?.emailId,
          sortOptions : sortOptions,
          globalFilterRequired : globalFilterRequired,
          ignoreFilter :ignoreFilter
        })
      )
        .unwrap()
        .then(() => {
          if (
            !allUsers?.length &&
            loggedInUserInfo?.modules?.find(
              (module) => module.module_id === current_module?.id
            )?.assign_poc
          ) {
            dispatch(
              getAllUsersByOrg({ id: loggedInUserInfo?.organisationInfo?._id })
            );
          }
        });
    }
    dispatch(setBulkVerifiedResponse(false))
  };



  const resetDashboardList = () => {
    if(current_module?.id && loggedInUserInfo?.organisationInfo?._id ){
      dispatch(
        getDashboardListDetails({
          module_id: current_module?.id,
          organisation_id: loggedInUserInfo?.organisationInfo?._id,
          limit: 10,
          skip: 0,
          searchText: '',
          user_data,
          selectedFilter: allFilterArray,
          emailId: loggedInUserInfo?.profileInfo?.emailId,
          sortOptions : sortOptions,
                    globalFilterRequired : globalFilterRequired,
                    ignoreFilter :ignoreFilter


        })
      )
      setListing(false)
    }
  };

  useEffect(() => {
    if (workflowDelete === "success") {
      getDashboardList();
    }
  }, [workflowDelete]);

  useEffect(() => {
    dispatch(clearUrlParams());
    dispatch(clearActivityList());
    dispatch(clearTotal());
    if (dashboardConfig?.fields) {
      getDashboardFields();
      let dashboardCheckboxList = {};
      const checkboxListFromLocal =
      JSON.parse(localStorage.getItem("dashboardCheckboxList")) || {};
      dashboardConfig?.fields.forEach((item, i) => {
        let { id, options, filter_level} = item;
        if (i > 3) {
          dashboardCheckboxList[item?.id] =
            checkboxListFromLocal[item?.id] || eval(item.show);
        }
        if (item?.filter_required) {
          if (item?.datatype == "date") {
            options = generateStartAndEnddate();
          }
        }
         function generateStartAndEnddate() {
           const today = new Date();
          //  today.setHours(0, 0, 0, 0);
           const endDate = today.toISOString();
           const result = options?.map((option) => {
             const startDate = new Date(today);
             startDate.setDate(today.getDate() - option.value);
            //  startDate.setHours(23, 59, 59, 999);
             const startDateString = startDate?.toISOString();
             return {
               id: option.id,
               lable: option.lable,
               value:option.value,
               start_date: startDateString,
               end_date: endDate,
             };
           });
           return result;
         }
      });
      const checkboxkeys = Object.keys(checkboxListFromLocal).length === 0  ?  dashboardCheckboxList : checkboxListFromLocal
      dispatch(setAllDashboardCkeckboxList(checkboxkeys));
    }
  }, [dashboardConfig]);

  useEffect(() => {
    if (tableListingData?.length > 0) {
      setDashboardTableListingData(tableListingData);
      setPagination((prev) => ({
        ...prev,
        count: Math.ceil(tableCount / 10) || 1,
      }));
    } else {
      setDashboardTableListingData([]);
      setPagination((prev) => ({
        ...prev,
        count: 1,
      }));
    }
  }, [tableListingData]);

  const getDashboardFields = () => {
    let dashboardFields = [];
    let dashboardFieldsCheckboxList = [];
    const checkboxListFromLocal =
      JSON.parse(localStorage.getItem("dashboardCheckboxList")) || {};
    dashboardConfig?.fields.forEach((item, i) => {
      if (
        item?.is_column_compulsory ||
        eval(item.show) ||
        checkboxListFromLocal[item?.id]
      ) {
        dashboardFields.push(item);
      }
      if (i > 3) {
        dashboardFieldsCheckboxList.push(item);
      }
    });
    if (Object.keys(checkboxListFromLocal).length > 1) {
      dashboardFields = dashboardFields.filter(
        (item) =>
          item?.is_column_compulsory ||
          checkboxListFromLocal[item?.id] !== false
      );
    }
    dashboardFields = dashboardFields.sort((a, b) => a?.order - b?.order);
    dashboardFieldsCheckboxList = dashboardFieldsCheckboxList.sort(
      (a, b) => a?.order - b?.order
    );
    dispatch(
      setDashboardState({ key: "dashboardFields", value: dashboardFields })
    );
    dispatch(
      setDashboardState({
        key: "dashboardFieldsCheckboxList",
        value: dashboardFieldsCheckboxList,
      })
    );
  };

  useEffect(() => {
    if (dashboardConfig?.fields) {
      getDashboardFields();
    }
  }, [checkboxList]);

  const handleCheckBoxChange = (payload) => {
    const list = { ...checkboxList };
    list[payload.key] = payload.value;
    localStorage.setItem("dashboardCheckboxList", JSON.stringify(list));

    dispatch(setDashboardCheckboxList(payload));
  };

  const handleDateFilterCheckBoxChanges = (payload) =>{
    const list = {...dateFilterCheckboxList};
    list[payload.key] = payload.value;
    dispatch(setDateFilterCheckboxList(payload));
  }

  const handleCheckboxClear = () => {
    const list = { ...checkboxList };
    Object.keys(list).forEach(
      (key) => (list[key] = key !== "icon" ? false : true)
    );
    localStorage.setItem("dashboardCheckboxList", JSON.stringify(list));
    
    dispatch(setAllDashboardCkeckboxList(list));

  };

  const handleApplyFilter = () => {
    let filteredObj = {};
    if(Object?.keys(selectedFilterCheckboxList) && Object?.keys(filterDropdownList)) {
      let filterItems = Object?.keys(filterDropdownList);
      Object?.keys(selectedFilterCheckboxList).map((item) => {
        if(filterItems.includes(item)) {
          let filterValue = filterDropdownList[item]?.value;
          let filterLevel = filterDropdownList[item]?.filterLevel;
          let selectedFilterValue = selectedFilterCheckboxList[item] || {};
          let filterLabel = [];
          Object?.entries(selectedFilterValue).map(([key, value]) => {
            if(value) {
              let data = filterValue.find((filter) => filter.id === key);
              filterLabel.push(data?.lable?data?.lable:null);
            }
          });
          let obj = {
            value: [...filterLabel],
            filterLevel: filterLevel
          };
          filteredObj[item] = obj;
        }
      })
      setAllFilterArray({...filteredObj});
      setPagination({
        pageNum: 1,
        count: 1
      })
    }
  }
  
  useEffect(() => {
    let sortFilterObj = {};
    let filteredObj = {};
    if(Object?.keys(selectedTableSortOptions) && Object?.keys(filterDropdownList)) {
      let filterItems = Object?.keys(filterDropdownList);
      Object?.keys(selectedTableSortOptions).map((item) => {
        if(filterItems.includes(item)) {
          let selectedFilterValue = selectedTableSortOptions[item];
          let sortDirection;
          let filterLevel = filterDropdownList[item]?.filterLevel;
          if(selectedFilterValue?.["+1"]) 
            sortDirection = "+1";
          else if(selectedFilterValue?.["-1"]) {
            sortDirection = "-1";
          }
          let obj = {
            fieldName: item,
            sortDirection: sortDirection,
            filterLevel: filterLevel
          };
          sortFilterObj[item] = obj;
        }
      })
      setSortOptions({...sortFilterObj});
      setPagination({
        pageNum: 1,
        count: 1
      })
    }
    if(Object?.keys(removeFilter) && Object?.keys(filterDropdownList)) {
      let filterItems = Object?.keys(filterDropdownList);
      Object?.keys(removeFilter).map((item) => {
        if(filterItems.includes(item)) {
          let filterValue = filterDropdownList[item]?.value;
          let filterLevel = filterDropdownList[item]?.filterLevel;
          let selectedFilterValue = removeFilter[item] || {};
          let filterLabel = [];
          Object?.entries(selectedFilterValue).map(([key, value]) => {
            if(value) {
              let data = filterValue.find((filter) => filter.id === key);
              filterLabel.push(data?.lable ? data?.lable:null);
            }
          });
          let obj = {
            value: [...filterLabel],
            filterLevel: filterLevel
          };
          filteredObj[item] = obj;
        }
      })
      setAllFilterArray({...filteredObj});
      setPagination({
        pageNum: 1,
        count: 1
      })
    }
    if(Object?.keys(selectedFilterCheckboxList) && Object?.keys(filterDropdownList)) {
      let filterItems = Object?.keys(filterDropdownList);
      Object?.keys(selectedFilterCheckboxList).map((item) => {
        if(filterItems.includes(item)) {
          let filterValue = filterDropdownList[item]?.value;
          let filterLevel = filterDropdownList[item]?.filterLevel;
          let selectedFilterValue = selectedFilterCheckboxList[item] || {};
          let filterLabel = [];
          Object?.entries(selectedFilterValue).map(([key, value]) => {
            if(value) {
              let data = filterValue.find((filter) => filter.id === key);
              filterLabel.push(data?.lable ? data?.lable:null);
            }
          });
          let obj = {
            value: [...filterLabel],
            filterLevel: filterLevel
          };
          filteredObj[item] = obj;
        }
      })
      setAllFilterArray({...filteredObj});
      setPagination({
        pageNum: 1,
        count: 1
      })
    }
  }, [selectedTableSortOptions, removeFilter, defaultTextFilter]);

  /**
   ** If the filter type is only sort then this function will be called
   * @param {*} id : ID of the field
   * @param {*} type : Data Type
   */
  const handleApplySort = (id, type) => {
    /**
     ** The following condition handles if the user clicks Apply without
     ** selecting any sort option 
     */
    if(!selectedTableSortOptions) {
      return setSortOptions(null);
    }
    /**
     *! Important note below
     ** Please note that the id param will hold the value of the field name on which the sort is to be applied
     ** and the selectedOptionDetails variable will hold the sort direction details in the following format
     ** There can be 2 values of selectedOptionDetails
     ** {"+1" : true}
     ** {"-1" : true}
     ** +1 Indicates oldest to newest
     ** -1 Indicates newest to oldest
     */
    let selectedOptionDetails = selectedTableSortOptions[id];

    let sortDirection;

    if(selectedOptionDetails?.["+1"]) 
      sortDirection = "+1";
    else if(selectedOptionDetails?.["-1"]) {
      sortDirection = "-1";
    }
    setSortOptions({
      fieldName : id,
      sortDirection : sortDirection
    })
  }

  const handleSortOptionChanges = (data) => {
    dispatch(setSelectedTableSortOptions(data))
  }

  const handleClearSort = () => {
    dispatch(setSelectedTableSortOptions({}));
  }

  const handleClearFilter = (type) => {
    setIgnoreFilter(true)
    let list = {}
    list.value = "";
    list.type = type;
    dispatch(setFilterCheckboxList(list));
    let filterObj = {...allFilterArray};
    delete filterObj[type];
    setAllFilterArray(filterObj);
  }

  const handleClearAllFilter = () =>{
    setIgnoreFilter(true)

    dispatch(
      getDashboardListDetails({
        module_id: current_module?.id,
        organisation_id: loggedInUserInfo?.organisationInfo?._id,
        limit: 10,
        skip: (pagination?.pageNum - 1) * 10,
        searchText: "",
        user_data,
        selectedFilter: {},
        emailId: loggedInUserInfo?.profileInfo?.emailId,
        sortOptions: {},
        globalFilterRequired : globalFilterRequired,
        ignoreFilter :ignoreFilter

      })
    )
    dispatch(clearAllFilterCheckBox());
  }

  const handlePageClick = (type,value) => {
    let pageNum = pagination?.pageNum || 1;
    switch (type) {
      case "first":
        pageNum = 1;
        break;
      case "prev":
        pageNum = pagination?.pageNum - 1;
        break;
      case "next":
        pageNum = pagination?.pageNum + 1;
        break;
      case "last":
        pageNum = pagination?.count;
        break;
      default:
        pageNum = 1;
        break;
    }
    if (changeRows) {
      dispatch(
        getDashboardListDetails({
          module_id: current_module?.id,
          organisation_id: loggedInUserInfo?.organisationInfo?._id,
          limit: 10,
          skip: (pageNum - 1) * 10,
          searchText: searchValue,
          user_data,
          selectedFilter:allFilterArray,
          emailId: loggedInUserInfo?.profileInfo?.emailId,
          sortOptions : sortOptions,
          globalFilterRequired : globalFilterRequired,
        ignoreFilter :ignoreFilter

        })
      );
      dispatch(setRowsChange(false));
      return;
    }
    if (pageNum === pagination?.pageNum) {
      return;
    }
    setPagination((prev) => ({
      ...prev,
      pageNum: pageNum,
    }));
    dispatch(
      getDashboardListDetails({
        module_id: current_module?.id,
        organisation_id: loggedInUserInfo?.organisationInfo?._id,
        limit: 10,
        skip: (pageNum - 1) * 10,
        searchText: searchValue,
        user_data,
        selectedFilter:allFilterArray,
        emailId: loggedInUserInfo?.profileInfo?.emailId,
        sortOptions: sortOptions,
        globalFilterRequired : globalFilterRequired,
        ignoreFilter :ignoreFilter

      })
    );
  };

  const updateWorkflow = (body) => {
    setInternalPOCUpdatedSuccessfully(false);
    dispatch(updateDataAndStatusById(body))
      .unwrap()
      .then((res) => {
        // Updated this code as the internal_poc key was hardcoded. For filtering, we now use internal_poc_name instead. This update ensures compatibility with both keys.
        // Extract the new internal_poc value from the response
        const internalPocValue =
          res?.updateInfo?.source_data?.internal_poc_name ||
          res?.updateInfo?.source_data?.internal_poc?.name;

        // Find and update the relevant row in dashboardTableListingData
        const listArray = dashboardTableListingData.map(item => {
          if (item.workflow_id === body?.userId) {
            // Check which key exists in the item (either internal_poc or internal_poc_name)
            const updatedItem = {
              ...item,
              // If internal_poc_name exists, update it, otherwise update internal_poc
              internal_poc_name: item.hasOwnProperty('internal_poc_name')
                ? internalPocValue
                : item.internal_poc_name,
              internal_poc: item.hasOwnProperty('internal_poc')
                ? internalPocValue
                : item.internal_poc,
            };
            return updatedItem;
          }
          return item; 
        });
        dispatch(
          setDashboardState({ key: "dashboardListingData", value: listArray })
        );
        setDashboardTableListingData(listArray);
        setInternalPOCUpdatedSuccessfully(true);

        //TODO: toast for success message "Internal POC updated successfully"
      });
  };

  function downloadCSVFile(csv) {
    var csvFile;
    var downloadLink;
    let filename = "misReport.csv";
    //define the file type to text/csv
    csvFile = new Blob([csv], { type: "text/csv" });
    downloadLink = document.createElement("a");
    downloadLink.download = filename;
    downloadLink.href = window.URL.createObjectURL(csvFile);
    downloadLink.style.display = "none";

    document.body.appendChild(downloadLink);
    downloadLink.click();
  }
  const downloadMISReportByFilter = async (lastdate) => {
    dispatch(setloadingAppplicantDataToDownload(true));
    let csvv = await downloadMISReport({
      module_id: current_module?.id,
      organisation_id: loggedInUserInfo?.organisationInfo?._id,
      limit: 10,
      skip: (pagination?.pageNum - 1) * 10,
      searchText: searchValue,
      user_data,
      emailId: loggedInUserInfo?.profileInfo?.emailId,
      lastdate: lastdate,
      selectedFilter: allFilterArray,
      sortOptions: sortOptions
    });
    dispatch(setloadingAppplicantDataToDownload(false));
    downloadCSVFile(csvv);
  };


  useEffect(() => {
    if(listing || searchValue ||  allFilterArray || sortOptions || bulkVerifiedResponse) {
      getDashboardList();
    }
    const isEmpty = Object.keys(allFilterArray).every((key) => Array.isArray(allFilterArray[key]) && allFilterArray[key].length === 0);   
    setClearFilter(isEmpty)
    setIsDownloadLoaded(false);
    calcSearchBarSize()
  }, [searchValue, current_module, allFilterArray, sortOptions, bulkVerifiedResponse]);

  useEffect(() => {
    if(current_module && !activeSelectedTab){
      <LoadingSpinner />
    }
    if(activeSelectedTab === 0 || activeSelectedTab){
      setPagination((prev) => ({
        ...prev,
        pageNum: 1,
      }));
      dispatch(setRowPerPage(numberOfRecords));
      setListing(true)
    }
  }, [current_module, activeSelectedTab])

  useEffect(() => {
    if(listing){
      resetDashboardList()
    }
  }, [listing])

  const handleCloseToast = () => {
    setInternalPOCUpdatedSuccessfully(false);
    setToast(false)
  };

  const closeModal = () => {
    setShowModal(false);
    setInvite(false);
  };
  const closeBulkModal = () => {
    setshowBulkModal(false);
    setBulkInvite(false)
  };
  const closeBulkAddModal = () => {
    setshowAddModall(false);
  };

  const setInviteToast = () => {
    setToast(true);
    setTimeout(() => {
      setToast(false);
    }, 3000);
  };
  const downloadReportWithFilter = (days) => {
    const lastdate = new Date();
    lastdate.setDate(lastdate.getDate() - days);
    setSmShow(false)
    downloadMISReportByFilter(lastdate)
  }

  const checkWindowWidth = () => {
    let windowWidth = window.innerWidth;
    if (windowWidth <= 768 && !isMobile) {
      setIsMobile(true)
    }
    else if (windowWidth > 768 && isMobile) {
      setIsMobile(false)
    }
  }
  const calcSearchBarSize = () => {
    if (currentUserRole?.add === true &&
      currentUserRole?.invite_customer === true) {
      setSearchBarSize('threefr-onefr');
      setCtaContainerStyle('d-grid')
    }
    else if (currentUserRole?.add === false &&
      currentUserRole?.invite_customer === false) {
      setSearchBarSize('')
    }
    else {
      setSearchBarSize('fivefr-onefr');
      setCtaContainerStyle('')
    }
  }
  const checkLoadingStatus = () => {
    if (loading || dashboardDataLoading) {
      setShow(true)
    } else if (!loading && !dashboardDataLoading) {
      setShow(false)
    }
  }
  useEffect(() => {
    checkLoadingStatus()
  }, [loading, dashboardDataLoading])


  const logout = () => {
    localStorage.clear();
    window.location.href = clientLogoutURL
        ? clientLogoutURL
        : "/accounts/login";

};

  window.addEventListener('resize', checkWindowWidth());

  return (
      <>
          {toast && (
              <Toast
                  onClose={() => handleCloseToast}
                  message="Invite sent successfully!"
                  type="success"
                  autoClose={3000}
              />
          )}
          {invite ? (
              <InviteCustomer
                  showModal={showModal}
                  closeModal={closeModal}
                  setInviteToast={setInviteToast}
              />
          // ) : Bulkinvite ? (
          //     <BulkInviteCustomer
          //         showModal={showBulkModal}
          //         closeModal={closeBulkModal}
          //     />
          ) : addbulk ? (
              <BulkAddCustomer
                  showModal={showAddModal}
                  closeModal={closeBulkAddModal}
              />
          ) : null}

          <DashBoard
              templateName={dashboardConfig?.template_name}
             sidebarStructure={dashboardConfig?.sidebar_structure}
              selectedData={selectedData}
              clearAllFilterArray ={clearAllFilterArray}
          >
        <Header headerStructure={headerStructure} downloadMISReportByFilter={
          downloadMISReportByFilter
        }
        value={searchValue}
        handlePageClick={handlePageClick}
        handleSearch={handleSearch}
        pagination={pagination}
        Download_icon={Download_icon}
        downloadEnable={download}
        currentUserRole={currentUserRole}
        dashboardConfig={dashboardConfig}
        clearAllFilter={handleClearAllFilter}
        setRemoveFilter={setRemoveFilter}
        searchBarConfig={searchBarConfig}
        filterDropdownList={filterDropdownList}
        setDefaultTextFilter={setDefaultTextFilter}
        handleClearAllFilter={handleClearAllFilter}
        />

              <Card customClass="">
                 
                  <Container fluid className="mb-2 mb-lg-0 mt-2">
                      {/* {loading ? (<></>):(
                   
                    )} */}
                      <Row>
                          {/* <Col xs={12} md={12} lg={12}>
                            {Object?.keys(dashboardConfig || {})?.length ? 
                              (
                                <Search
                                  className=".homepage_search bg-white"
                                  value={searchValue}
                                  handlePageClick={handlePageClick}
                                  handleSearch={handleSearch}
                                  pagination={pagination}
                                  downloadMISReportByFilter={
                                      downloadMISReportByFilter
                                  }
                                  Download_icon={Download_icon}
                                  downloadEnable={download}
                                  currentUserRole={currentUserRole}
                                  dashboardConfig={dashboardConfig}
                                  clearAllFilter={handleClearAllFilter}
                                  setRemoveFilter={setRemoveFilter}
                                  searchBarConfig={searchBarConfig}
                                  filterDropdownList={filterDropdownList}
                                  setDefaultTextFilter={setDefaultTextFilter}
                                />
                              ) : null
                            }
                          </Col> */}
                      </Row>
                      <Modal
                          size=""
                          show={smShow}
                          onHide={() => setSmShow(false)}
                          aria-labelledby="example-modal-sizes-title-sm"
                      >
                          <Modal.Body>
                              <div
                                  style={{
                                      display: 'flex',
                                      justifyContent: 'space-between'
                                  }}
                              >
                                  <button
                                      style={{
                                          border: 'none',
                                          background: 'none'
                                      }}
                                      type="button"
                                      onClick={(e) =>
                                          downloadReportWithFilter(7)
                                      }
                                  >
                                      {' '}
                                      <Image imageSrc={Download_icon} /> Last 7
                                      days
                                  </button>
                                  <button
                                      style={{
                                          border: 'none',
                                          background: 'none'
                                      }}
                                      type="button"
                                      onClick={(e) =>
                                          downloadReportWithFilter(15)
                                      }
                                  >
                                      <Image imageSrc={Download_icon} /> Last 15
                                      days
                                  </button>
                                  <button
                                      style={{
                                          border: 'none',
                                          background: 'none'
                                      }}
                                      type="button"
                                      onClick={(e) =>
                                          downloadReportWithFilter(30)
                                      }
                                  >
                                      <Image imageSrc={Download_icon} /> Last 30
                                      Days
                                  </button>
                              </div>
                          </Modal.Body>
                      </Modal>
                  </Container>
                  {internalPOCUpdatedSuccessfully && (
                      <Toast
                          // onClose setInternalPOCUpdatedSuccessfully to false and show toast for 3 seconds
                          onClose={() => handleCloseToast}
                          message="Internal POC updated successfully!"
                          type="success"
                          autoClose={3000}
                      />
                  )}
                  {/* Applicant List */}

                  {loading || sidebarLoading ? (
                      <></>
                  ) : (
                      <div
                          className={`${
                              isMobile
                                  ? ''
                                  : '.homepage_content py-0 my-2 mx-lg-3 bg-grey-theme'
                          }`}
                      >
                          <Card className=".d-flex .flex-column justify-content-between .dashboard-detail-container-height .overflow-y-scroll .theme-scrollbar bg-white">
                              <TableComponent
                                  fields={dashboardFields}
                                  tableListingData={dashboardTableListingData}
                                  checkboxFields={dashboardFieldsCheckboxList}
                                  filterDropdownList={filterDropdownList}
                                  checkboxList={checkboxList}
                                  selectedFilterCheckboxList={
                                      selectedFilterCheckboxList
                                  }
                                  selectedTableSortOptions={
                                    selectedTableSortOptions
                                  }
                                  handleSortOptionChanges={handleSortOptionChanges}
                                  dateFilterCheckboxList={
                                      dateFilterCheckboxList
                                  }
                                  setCheckboxList={handleCheckBoxChange}
                                  // setFilterCheckboxList={
                                  //     handleStatusFilterCheckBoxChanges
                                  // }
                                  setDateFilterCheckboxList={
                                      handleDateFilterCheckBoxChanges
                                  }
                                  handleCheckboxClear={handleCheckboxClear}
                                  handleApplyFilter={handleApplyFilter}
                                  handleApplySort={handleApplySort}
                                  handleClearFilter={handleClearFilter}
                                  handleClearSort={handleClearSort}
                                  clearAllFilter={handleClearAllFilter}
                                  pagination={pagination}
                                  handlePageClick={handlePageClick}
                                  currentUserRole={currentUserRole}
                                  showClearFilter={showClearFilter}
                                  updateWorkflow={updateWorkflow}
                                  dashboardConfig={dashboardConfig}
                                  // verificationListingData={tableListingData}
                                  clearAllSortArray ={clearAllsortArray}
                              />
                          </Card>
                      </div>
                  )}
              </Card>
              {sessiontimeout && <Autologout duration={defaultDuration} />}
              {loading ? (
                  <></>
              ) : (
                  <>
                      <Row className="z-index-5 position-sticky bottom-0 mx-3 bg-white d-none d-lg-block">
                          <Col xs={12} md={12} lg={12}>
                              <div className="bg-white w-100 d-flex align-items-center justify-content-end">
                                  <p className="fs-13px mb-0 me-1 mt-1">
                                      Powered by
                                  </p>
                                  <Image imageSrc={signdeskLogo} />
                              </div>
                          </Col>
                      </Row>
                      <div className="text-center py-3 d-lg-none position-sticky bottom-0 bg-white">
                          <PaginationComponent
                              pagination={pagination}
                              handlePageClick={handlePageClick}
                          />
                      </div>
                  </>
              )}
              {/* {poweredBy && (
          <div className="signdesk_logo">
            <p>Powered by</p>
            <Image src={Sign_desk_logo} alt="signDesk_logo" />
          </div>
        )} */}
          </DashBoard>
          <Modal
              show={show}
              onHide={handleClose}
              backdrop="static"
              keyboard={false}
              centered
              animation={false}
              className="bg-modal-transparent modal-no-br modal-no-border"
          >
              <Modal.Body className="d-flex justify-content-center">
                  <div className="loader " />
              </Modal.Body>
          </Modal>
      </>
  );
};

export default HomePage;
